import styled, { css } from "styled-components";
import { Screen, Color, FontSize } from 'styles';

const SmallHeaderDescriptionStyle = css`
  display: block;
  font-size: ${FontSize.M};
  margin-left: 0;  
  text-align: center;
`;

export const StyledElementHeaderDescription = styled.span`
  color: ${Color.Orange};
  display: inline-block;
  font-size: ${FontSize.L};
  margin-left: 15px;
  
  ${Screen.small(SmallHeaderDescriptionStyle)}
`;


// WEBPACK FOOTER //
// ./src/utils/styledElements/headerDescription/headerDescription.style.js